import { ReactNode, useState } from 'react';

import { DialogConfirmation } from '@uiKit/DialogConfirmation';

import { ValidationData } from '../types';

type ValidationExitGuardResult = {
  guardedExit: () => void;
  exitConfirmDialog: ReactNode;
};

export const useValidationExitGuard = (
  validationData: ValidationData | undefined,
  onExit: () => void,
): ValidationExitGuardResult => {
  const [confirmOpen, setConfirmOpen] = useState(false);

  const guardRequired = !!validationData && Object.keys(validationData).length > 0;

  const guardedExit = () => {
    if (guardRequired) {
      setConfirmOpen(true);
    } else {
      onExit();
    }
  };

  const exitConfirmDialog = confirmOpen ? (
    <DialogConfirmation
      open
      maxWidth="xs"
      title="Exit and discard validation?"
      content="If you exit now, you’ll need to revalidate the items before completing the request."
      acceptButtonTitle="Exit"
      acceptButtonProps={{ variant: 'text' }}
      cancelButtonTitle="Keep Validation"
      acceptButtonHandleClick={() => {
        setConfirmOpen(false);
        onExit();
      }}
      cancelButtonHandleClick={() => setConfirmOpen(false)}
    />
  ) : null;

  return { guardedExit, exitConfirmDialog };
};
